export const INTERNAL_HOST_DISPATCH = Symbol('__internal_host_dispatch__');
